import { type TYachtSetupFields } from "./yachtSetup.types";

export const getDefaultValuesFromFields = (fields: TYachtSetupFields) => {
  const defaultValues: Record<string, string | null> = {};
  fields.forEach(field => {
    defaultValues[field.name] = field.type === "date" ? null : "";
  });
  return defaultValues;
};
